import { render, staticRenderFns } from "./blogCategories.vue?vue&type=template&id=b9781ab0"
import script from "./blogCategories.vue?vue&type=script&lang=js"
export * from "./blogCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports